import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import collaborationImage from "@/assets/collaboration.jpg";
const reasons = [{
  number: "01",
  title: "Altijd dezelfde persoon",
  description: "Je hebt met mij te maken. Niet met een helpdesk, niet met wisselende contactpersonen. Ik ken je situatie en pak zaken direct op."
}, {
  number: "02",
  title: "Korte lijnen",
  description: "Bellen, mailen of een online meeting. Je krijgt snel antwoord en weet waar je aan toe bent."
}, {
  number: "03",
  title: "Structureel ontzorgen",
  description: "Geen eenmalig project en dan verdwijnen. Ik blijf betrokken met onderhoud, updates en optimalisatie."
}, {
  number: "04",
  title: "Focus op resultaat",
  description: "Alles wat ik doe heeft een doel. Geen overbodige toeters en bellen, wel oplossingen die werken."
}];
export function WhyMe() {
  return <section className="section-padding gradient-bg text-white overflow-hidden">
      <div className="container-wide">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-stretch">
          {/* Image column */}
          <div className="order-2 lg:order-1 flex">
            <div className="w-full rounded-xl overflow-hidden shadow-2xl">
              <img
              alt="Samenwerking met klanten"
              className="w-full h-full object-cover"

              width={544}
              height={842}
              sizes="(max-width: 1024px) 90vw, 544px"
              loading="lazy"
              decoding="async" src="/lovable-uploads/28c6d360-46c0-4706-9e71-8fb5bc1399f9.png" />
            
            </div>
          </div>
          
          {/* Content column */}
          <div className="order-1 lg:order-2">
            <p className="text-sm uppercase tracking-widest mb-4 text-white/70">Waarom Online Sale Specialist    </p>
            <h2 className="mb-6 text-white">Waarom klanten voor mij kiezen</h2>
            <p className="text-white/80 mb-10">
              Online zaken kunnen ingewikkeld lijken. Ik maak het simpel: één aanspreekpunt dat alles voor je regelt.
            </p>

            <div className="space-y-8">
              {reasons.map((reason) => <div key={reason.number} className="flex gap-5">
                  <span className="text-3xl font-bold text-white/20 leading-none shrink-0">
                    {reason.number}
                  </span>
                  <div>
                    <h3 className="mb-1 text-white text-lg font-semibold">{reason.title}</h3>
                    <p className="text-white/85 text-sm leading-relaxed">{reason.description}</p>
                  </div>
                </div>)}
            </div>

            <div className="mt-10">
              <Button asChild size="lg" variant="secondary" className="bg-white text-primary hover:bg-white/90">
                <Link to="/over-mij">
                  Lees meer over mijn aanpak
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}